import type { AggregatedResultItem } from '@cognite/sdk';

type SpaceExternalIdKey = `${string}::${string}`;

/**
 * Maps DMS instance aggregate rows (grouped by `parent`) to child counts per parent,
 * using keys compatible with {@link CdmAssetService.getChildrenCounts} callers (`space::externalId`).
 */
export const mapInstanceAggregateItemsToParentChildCounts = (
  items: AggregatedResultItem[]
): Record<SpaceExternalIdKey, number> => {
  const counts: Record<SpaceExternalIdKey, number> = {};
  for (const item of items) {
    const parent = item.group?.parent;
    if (
      typeof parent === 'object' &&
      parent !== null &&
      'externalId' in parent &&
      'space' in parent
    ) {
      const aggregate = item.aggregates[0];
      counts[`${parent.space}::${parent.externalId}`] =
        aggregate && 'value' in aggregate ? (aggregate.value ?? 0) : 0;
    }
  }
  return counts;
};
